import * as React from "react";
import { Paper, Text, Button, rem, useMantineColorScheme } from "@mantine/core";
import { Upload } from "lucide-react";

interface FileUploadDropzoneProps {
    isDragging: boolean;
    onDrop: (e: React.DragEvent) => void;
    onDragOver: (e: React.DragEvent) => void;
    onDragLeave: (e: React.DragEvent) => void;
    onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function FileUploadDropzone({
    isDragging,
    onDrop,
    onDragOver,
    onDragLeave,
    onFileChange
}: FileUploadDropzoneProps) {
    const { colorScheme } = useMantineColorScheme();

    return (
        <Paper
            withBorder
            p={60}
            radius="md"
            style={{
                borderStyle: 'dashed',
                borderColor: isDragging
                    ? 'var(--mantine-color-brand-filled)'
                    : (colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'var(--mantine-color-gray-4)'),
                backgroundColor: isDragging
                    ? (colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'var(--mantine-color-brand-light)')
                    : (colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'transparent'),
                transition: 'all 0.2s ease',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer'
            }}
            onDrop={onDrop}
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onClick={() => document.getElementById('file-upload')?.click()}
        >
            <input
                type="file"
                id="file-upload"
                style={{ display: 'none' }}
                accept=".json,.csv,.xlsx,.xls"
                onChange={onFileChange}
            />
            <Upload
                size={48}
                strokeWidth={1.5}
                style={{
                    color: colorScheme === 'dark' ? 'var(--mantine-color-white)' : 'var(--mantine-color-brand-filled)',
                    marginBottom: rem(16)
                }}
            />
            <Text size="xl" fw={600} ta="center">
                Drop your file here to explore
            </Text>
            <Text size="sm" c={colorScheme === 'dark' ? 'gray.5' : 'dimmed'} ta="center" mt={4}>
                Support for JSON, CSV, and Excel files. No data is stored on our servers.
            </Text>
            <Button
                color="black"
                c="white"
                mt="xl"
                onClick={(e) => {
                    e.stopPropagation();
                    document.getElementById('file-upload')?.click();
                }}
            >
                Select File
            </Button>
        </Paper>
    );
}
